<template>
  <div class="content">
    <van-nav-bar title="消费记录"  left-arrow @click-left="$router.go(-1)" fixed />
    <div class="page-infinite-wrapper" ref="wrapper" :style="{ height: wrapperHeight + 'px' }">
      <div v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="50">
        <div class="cell" v-for="(item, index) in data">
          <wv-group :title="item.created_at">
            <wv-cell v-model="item.amount" v-if="item.type === 'O'" is-link :to="{name:'expenseCalendar', query: { code: item.code }}">
              <span slot="bd" class="left">{{item.shop}} 消费</span>
            </wv-cell>
            <wv-cell v-model="item.amount" v-if="item.type === 'D'" is-link :to="{name:'recharge', query: { code: item.code }}" style="color: #09bb07">
              <span slot="bd" class="left">{{item.shop}} 充值</span>
            </wv-cell>
          </wv-group>
        </div>
      </div>
      <p v-show="loading" class="loading-tips">
        <wv-spinner type="snake" color="#444" :size="24" />
      </p>
    </div>
  </div>
</template>
<script>
import { getDataById } from '@/api/login'

export default {
  created() {
    // this.fechData()
  },
  name: 'expense',
  data() {
    return {
      id: null,
      data: [],
      loading: false,
      allLoaded: false,
      wrapperHeight: 0,
      page: 1
    }
  },
  methods: {
    loadMore() {
      if (this.allLoaded) {
        return
      }
      console.log('loading more')
      this.loading = true
      getDataById(this.$route.query.id, this.page).then(res => {
        this.data = this.data.concat(res.results)
        this.allLoaded = !res.has_more
        console.log(res)
        this.$nextTick(() => {
          this.loading = false
          this.page++
        })
      })
    },
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.content{
  background-color: red
}
.cell {
  padding: 2% 1%;
}

.weui-cell {
  font-size: 14px;
  color: #F56C6C;
}

.left {
  float: left;
}
</style>



// WEBPACK FOOTER //
// src/components/cards/expense.vue